import React, {Component} from 'react';
import qs from 'qs';
import '../styles/formpub.css';
import { updateAds, loadWebsite } from '../services/formpubService';
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  Button,
  Snackbar,
  Alert,
  CircularProgress
} from '@mui/material';

class Formpub extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_header: true,
      active_responsive: true,
      active_mobile: true,
      active_widget: true,
      header: '',
      responsive: '',
      mobile: '',
      widget: '',
      submitting: false,
      snackbar: { open: false, severity: 'success', message: '' }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.queriesForm = this.queriesForm.bind(this);
    this.closeSnackbar = this.closeSnackbar.bind(this);
  }

  closeSnackbar() {
    this.setState({ snackbar: { ...this.state.snackbar, open: false } });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  async queriesForm(event) {
    event.preventDefault();
    const parsed = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});

    this.setState({ submitting: true });
    try {
      await updateAds(parsed.website_id, this.state);
      this.setState({ snackbar: { open: true, severity: 'success', message: 'Mise à jour enregistrée.' } });
    } catch (e) {
      this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur lors de l’enregistrement.' } });
    } finally {
      this.setState({ submitting: false });
    }
  }

  async componentDidMount() {
    const parsed = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
    const website = await loadWebsite(parsed.website_id);
    this.setState({
      active_header: website.ads.header.active,
      header: website.ads.header.content || '',
      active_responsive: website.ads.responsive.active,
      responsive: website.ads.responsive.content || '',
      active_mobile: website.ads.mobile.active,
      mobile: website.ads.mobile.content || '',
      active_widget: website.ads.widget.active,
      widget: website.ads.widget.content || ''
    });
  }

  render() {
    const { submitting, snackbar } = this.state;

    return (
      <Box sx={{ p: 2 }}>
        <Paper variant="outlined" sx={{ p: 3, maxWidth: 900, mx: 'auto' }}>
          <Typography variant="h6" sx={{ mb: 2 }}>ADS</Typography>

          <Box component="form" onSubmit={(e) => this.queriesForm(e)}>
            <Stack spacing={3}>
              <FormControlLabel
                control={<Switch name="active_header" checked={this.state.active_header} onChange={this.handleInputChange} />}
                label="Active Header"
              />
              <TextField
                label="Contenu header"
                name="header"
                value={this.state.header}
                onChange={this.handleInputChange}
                fullWidth
                multiline
                minRows={6}
              />

              <FormControlLabel
                control={<Switch name="active_responsive" checked={this.state.active_responsive} onChange={this.handleInputChange} />}
                label="Active Responsive"
              />
              <TextField
                label="Contenu Responsive"
                name="responsive"
                value={this.state.responsive}
                onChange={this.handleInputChange}
                fullWidth
                multiline
                minRows={6}
              />

              <FormControlLabel
                control={<Switch name="active_mobile" checked={this.state.active_mobile} onChange={this.handleInputChange} />}
                label="Active Mobile"
              />
              <TextField
                label="Contenu Mobile"
                name="mobile"
                value={this.state.mobile}
                onChange={this.handleInputChange}
                fullWidth
                multiline
                minRows={6}
              />

              <FormControlLabel
                control={<Switch name="active_widget" checked={this.state.active_widget} onChange={this.handleInputChange} />}
                label="Active Widget"
              />
              <TextField
                label="Contenu Widget"
                name="widget"
                value={this.state.widget}
                onChange={this.handleInputChange}
                fullWidth
                multiline
                minRows={6}
              />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={submitting}
                  startIcon={submitting ? <CircularProgress size={18} /> : null}
                >
                  {submitting ? 'Saving...' : 'Save'}
                </Button>
              </Box>
            </Stack>
          </Box>
        </Paper>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={this.closeSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={this.closeSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default Formpub;